// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__-2gw7","lds_roller":"Loading_lds_roller__dcr7M"};